import { Pencil, Trash2 } from 'lucide-react';
import { Button, Card, CardBody, Pill } from '@/shared/components';
import type { ParkingSpotResponse } from '@/shared/api';

interface Props {
  spots: ParkingSpotResponse[];
  propertyNames: Map<string, string>;
  onEdit: (spot: ParkingSpotResponse) => void;
  onDelete: (spot: ParkingSpotResponse) => void;
}

export function ObjectParkingCards({ spots, propertyNames, onEdit, onDelete }: Props) {
  return (
    <div className="grid gap-3 md:grid-cols-2">
      {spots.map((spot) => (
        <Card key={spot.id}>
          <CardBody className="flex items-start justify-between gap-4 py-5">
            <div>
              <div className="flex items-center gap-2">
                <h3 className="text-ink font-serif text-xl">{spot.label}</h3>
                <Pill variant={spot.isActive ? 'on' : 'outline'} size="sm">
                  {spot.isActive ? 'Aktiv' : 'Inaktiv'}
                </Pill>
              </div>
              <p className="text-ink-soft mt-1 text-sm">
                {spot.price.toFixed(2)} {spot.currency} ·{' '}
                {spot.priceUnit === 'PerNight' ? 'pro Nacht' : 'pro Aufenthalt'}
              </p>
              <p className="text-ink-faint mt-2 text-xs">
                Zugewiesen:{' '}
                {spot.assignedPropertyIds.map((id) => propertyNames.get(id) ?? id).join(', ')}
              </p>
            </div>
            <div className="flex gap-1">
              <Button
                size="icon"
                aria-label={`${spot.label} bearbeiten`}
                onClick={() => onEdit(spot)}
              >
                <Pencil size={15} />
              </Button>
              <Button
                size="icon"
                aria-label={`${spot.label} entfernen`}
                onClick={() => onDelete(spot)}
              >
                <Trash2 size={15} />
              </Button>
            </div>
          </CardBody>
        </Card>
      ))}
    </div>
  );
}
